

import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import axios from 'axios'
import VueAxios from 'vue-axios'

import actualidadModule from '@/store/actualidad'
import promocionesModule from '@/store/promociones'
import formulariosModule from '@/store/formularios'

import VeeValidate, {Validator} from 'vee-validate';
import validatorEs from '@/validator/es';
import validatorEn from '@/validator/en';

import messages from '@/translations';


export const store = new Vuex.Store({
  state :{
    language: "es",
    // server : 'http://192.168.1.106:80/projects/risi/public/'
    server : 'https://back.risi.es'
  },
  actions :{
    changeLanguage : ({commit}, actualLang) => {
      return new Promise((resolve, reject) => {
        let nextLang = (actualLang == "es") ? "en" : "es";
        commit('setLanguage', nextLang);
        switch (nextLang) {
          case "es":
          Validator.localize('es', validatorEs);
          break;
          case "en":
          Validator.localize('en', validatorEn);
          break;
        }
        resolve(nextLang);
      });
    },
  },
  getters : {
    getLanguage : state => state.language,
    getServer : state => state.server,
    getTexts : state => {
      return messages[state.language];
    }
  },
  mutations : {
    setLanguage (state, lang){
      state.language = lang;
      localStorage.setItem('language', lang);      
    }
  },
  modules :{
    actualidadModule,
    promocionesModule,
    formulariosModule
  }
});




// WEBPACK FOOTER //
// ./src/store/store.js